var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDisplay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.35,31.51H3.65c-1.03,0-1.96-0.45-2.61-1.14l0,0C0.39,29.68,0,28.73,0,27.71l0,0V5.09 c0-1.02,0.39-1.97,1.04-2.66l0,0c0.65-0.69,1.58-1.14,2.61-1.14l0,0h32.71c1.03,0,1.96,0.45,2.61,1.14l0,0 C39.61,3.13,40,4.07,40,5.09l0,0v22.62h0c0,1.02-0.39,1.97-1.04,2.66l0,0C38.31,31.06,37.38,31.51,36.35,31.51L36.35,31.51 C36.35,31.51,36.35,31.51,36.35,31.51L36.35,31.51z M2.89,4.17C2.67,4.39,2.53,4.72,2.53,5.09l0,0v22.62 c0,0.38,0.14,0.7,0.35,0.92l0,0c0.22,0.22,0.47,0.34,0.76,0.34l0,0h32.71c0.29,0,0.55-0.12,0.76-0.34l0,0 c0.21-0.23,0.35-0.55,0.35-0.92l0,0h0l0-22.62c0-0.38-0.14-0.7-0.35-0.92l0,0c-0.22-0.23-0.47-0.34-0.76-0.34l0,0H3.65 C3.36,3.83,3.1,3.94,2.89,4.17L2.89,4.17z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 15.44,
    y: 29.14,
    className: "st0",
    width: 9.11,
    height: 9.11
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 9.03,
    y: 35.67,
    className: "st0",
    width: 21.94,
    height: 3.04
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisplay);
export default __webpack_public_path__ + "static/media/display.f0a73d1051e7e321f566ffd14117a9cf.svg";
export { ForwardRef as ReactComponent };